import * as Validator from "yup"

export const passwordValidatorRegex =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{9,15}$/

export const passwordValidator = Validator.string().matches(
	passwordValidatorRegex,
	"Please provide stronger password"
)
